module.exports = __webpack_public_path__ + "static/WW_1920x900.4fd5e683.jpg";